var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v("Wording")])]
          ),
          _vm._v(" "),
          _c("el-row", [
            _c("p", [
              _vm._v(
                "Das Wording wird im Front-End der Applikation angezeigt.\n                Änderungen sind sofort aktiv!"
              )
            ])
          ]),
          _vm._v(" "),
          _c("el-row"),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _vm.user_is_admin
                ? _c("el-col", { attrs: { span: 6 } }, [_vm._v("Supplier:")])
                : _vm._e(),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 6 } }, [_vm._v("Schlüssel:")]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 6 } }, [_vm._v("Bezeichnungen:")])
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.wording, function(word, index) {
            return _c(
              "el-row",
              { key: word.id, attrs: { gutter: 20 } },
              [
                _vm.wording !== null
                  ? _c(
                      "el-form",
                      { ref: "word", refInFor: true, attrs: { model: word } },
                      [
                        _vm.user_is_admin
                          ? _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c("el-form-item", [
                                  _c("p", {
                                    staticStyle: { "font-size": "17px" },
                                    domProps: {
                                      textContent: _vm._s(word.supplier_name)
                                    }
                                  })
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { disabled: !_vm.keyFieldEnabled },
                                  on: {
                                    change: function($event) {
                                      return _vm.hasChanged(index)
                                    }
                                  },
                                  model: {
                                    value: word.key,
                                    callback: function($$v) {
                                      _vm.$set(word, "key", $$v)
                                    },
                                    expression: "word.key"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  on: {
                                    change: function($event) {
                                      return _vm.hasChanged(index)
                                    }
                                  },
                                  model: {
                                    value: word.label,
                                    callback: function($$v) {
                                      _vm.$set(word, "label", $$v)
                                    },
                                    expression: "word.label"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              staticStyle: { display: "none" },
                              attrs: { type: "hidden" },
                              model: {
                                value: word.id,
                                callback: function($$v) {
                                  _vm.$set(word, "id", $$v)
                                },
                                expression: "word.id"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            word.changed
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      icon: word.btnIcon,
                                      type: word.btnType
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.submitUpdateForm(
                                          index,
                                          word.key
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(word.submitLabel) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 1 } },
                          [
                            _vm.deleteBtnEnabled
                              ? _c("el-button", {
                                  attrs: {
                                    icon: "el-icon-delete",
                                    type: "danger"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.submitDeleteForm(
                                        index,
                                        word.id
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("el-row"),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("span", [_vm._v("Key-Felder aktivieren")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-switch", {
                        attrs: { "active-text": "Ein", "inactive-text": "Aus" },
                        model: {
                          value: _vm.keyFieldEnabled,
                          callback: function($$v) {
                            _vm.keyFieldEnabled = $$v
                          },
                          expression: "keyFieldEnabled"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.keyFieldEnabled
                    ? _c(
                        "el-row",
                        [
                          _c("el-alert", {
                            attrs: {
                              title: "Achtung",
                              type: "warning",
                              description:
                                "Wenn sie die Keys ändern muss unter Umständen\n                                    auch die Frontend-Applikation angepasst werden! Ändern\n                                    sie die Keys nur, wenn sie wissen was sie tun!",
                              "show-icon": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("span", [_vm._v("Löschen aktivieren")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-switch", {
                        attrs: { "active-text": "Ein", "inactive-text": "Aus" },
                        model: {
                          value: _vm.deleteBtnEnabled,
                          callback: function($$v) {
                            _vm.deleteBtnEnabled = $$v
                          },
                          expression: "deleteBtnEnabled"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.deleteBtnEnabled
                    ? _c(
                        "el-row",
                        [
                          _c("el-alert", {
                            attrs: {
                              title: "Achtung",
                              type: "warning",
                              description:
                                "Wenn sie Key-Label Paare löschen muss unter Umständen\n                                    auch die Frontend-Applikation angepasst werden! Löschen\n                                    sie Keys nur, wenn sie wissen was sie tun!",
                              "show-icon": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row"),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v("Neus Key-Label Paar erstellen")])]
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-form",
                { ref: "newWord", attrs: { model: _vm.newWord } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.newWord.key,
                              callback: function($$v) {
                                _vm.$set(_vm.newWord, "key", $$v)
                              },
                              expression: "newWord.key"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.newWord.label,
                              callback: function($$v) {
                                _vm.$set(_vm.newWord, "label", $$v)
                              },
                              expression: "newWord.label"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitCreateForm()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.createBtnText) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2716a54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2716a54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/pages/wording/template.html
// module id = null
// module chunks = 